<div class="page-wrapper">
  <div class="sell-wrapper">
    <div class="header">
      <h1>Real Estate. Real Simple. Rebuilt.</h1>
      <h6>No fees. No commissions. Free offer!</h6>
    </div>

    <div class="inputs">
      <div class="input-zone">
        <app-sell-verify-address
          *ngIf="step === 'verify-address'"
          (selectAddress)="selectAddress($event)"
        ></app-sell-verify-address>
      </div>

      <app-shared-button
        theme="primary"
        size="large"
        class="items-center hover:cursor-pointer p-3 button"
        [loading]="loading"
        [disabled]="!address"
        (click)="sendSelectedData()"
      >
        Get&nbsp;My&nbsp;Offer
      </app-shared-button>
    </div>
  </div>
</div>
